import React from 'react';
import Modal from '../../../base/modal';
import AppButton from '../../../base/button';
import { IGetBeneficiary } from '../../../../models/beneficiary.model';

interface DeleteBeneficiaryProps {
  isOpen: boolean;
  toggleModal: () => void;
  selectedBeneficiary: IGetBeneficiary | null;
  onConfirmDelete: () => Promise<void>;
  loading: boolean;
}

const DeleteBeneficiary: React.FC<DeleteBeneficiaryProps> = ({
  isOpen,
  toggleModal,
  selectedBeneficiary,
  onConfirmDelete,
  loading,
}) => {
  return (
    <Modal isOpen={isOpen} toggleModal={toggleModal} width="w-[560px] h-fit">
      <div className="p-6">
        <h2 className="text-xl font-bold mb-4">Delete Beneficiary</h2>
        <p className="text-gray-600 mb-6">
          Are you sure you want to delete{' '}
          {selectedBeneficiary?.accountHolderName}? This action cannot be undone.
        </p>
        <div className="flex justify-end gap-4">
          <AppButton label="Cancel" type="light" clicked={toggleModal} />
          <AppButton
            label="Delete"
            type="danger"
            clicked={onConfirmDelete}
            loading={loading}
          />
        </div>
      </div>
    </Modal>
  );
};

export default DeleteBeneficiary;
